import styled from "styled-components";

export const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    padding-top: 2rem;
    @media ${(props) => 'screen and (max-width: 475px)'} { 
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto 1fr;
    }
    @media ${(props) => 'screen and (max-width: 900px)'} { 
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto 1fr;
        padding-top: 1.5rem;
    }
`;

export const Div1 = styled.div`
    color: #fff;
    font-size: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${(props) => 'screen and (max-width: 475px)'} { 
        grid-row: 1;
        grid-column: 1;
    }
    @media ${(props) => 'screen and (max-width: 900px)'} { 
        grid-row: 1;
        grid-column: 1;
        font-size: 22px;
    }
`;


export const Div2 = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    @media ${(props) => 'screen and (max-width: 475px)'} { 
        grid-row: 2;
        grid-column: 1 / span 2;
    }
    @media ${(props) => 'screen and (max-width: 900px)'} { 
        grid-row: 2;
        grid-column: 1 / span 2;
    }
`;

export const Div3 = styled.div`
    @media ${(props) => 'screen and (max-width: 475px)'} { 
        grid-row: 1;
        grid-column: 2;
    }
    @media ${(props) => 'screen and (max-width: 900px)'} { 
        grid-row: 1;
        grid-column: 2;
    }
`;

export const NavLink = styled.a`
    display: inline-block;
    font-size: 22px;
    color: rgba(255, 255, 255, 0.75);
    @media ${(props) => 'screen and (max-width: 475px)'} { 
        font-size: 16px;
    }
    @media ${(props) => 'screen and (max-width: 900px)'} { 
        font-size: 18px;
    }
    &:hover {
        transform: scale(1.2);
        cursor: pointer;
        color: white;
        transition: 0.3s ease;
        opacity: 1;
        &::after {
            content: "";
            position: absolute;
            bottom: -12px;
            left: 0;
            width: 100%;
            height: 2px;
    
            background-color: orange; 
    
            transform: scaleX(1);
            transform-origin: bottom;
            transition: transform 0.2s ease-in-out;
        }
    }
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: transparent; 
        transform: scaleX(0);
        transform-origin: bottom;
        transition: transform 0.2s ease-in-out;
    
    }
`;

export const NavLinksContainer = styled.div`
    display: flex; 
    justify-content: space-between;
    width: 100%; 
`;

export const SocialIcons = styled.a`
    display: inline-block;
    position: relative;
    transition: 0.3s ease;
    color: white; 
    border-radius: 50px;
    padding: 8px;
    @media ${(props) => 'screen and (max-width: 900px)'} { 
        transform: scale(1);
    }
    &:hover {
        transform: scale(1.2);
        cursor: pointer;
        &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;

        background-color: orange; 

        transform: scaleX(1);
        transform-origin: bottom;
        transition: transform 0.2s ease-in-out;
        }
    }
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: transparent; 
        transform: scaleX(0);
        transform-origin: bottom;
        transition: transform 0.2s ease-in-out;
    }
`;
